import { render, staticRenderFns } from "./ContractTemplates.vue?vue&type=template&id=b33d1064&scoped=true"
import script from "./ContractTemplates.vue?vue&type=script&lang=js"
export * from "./ContractTemplates.vue?vue&type=script&lang=js"
import style0 from "./ContractTemplates.vue?vue&type=style&index=0&id=b33d1064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33d1064",
  null
  
)

export default component.exports